import { FC } from 'react'

import { OrderPaidStatus } from 'features/OrderPreview/ui/components/OrderPaidStatus'
import { DetailOrder } from 'entities/orders/model'
import { Flex } from 'shared/components/Flex'

import { StyledFooterContainer, StyledItemsContainer, List } from './styles'
import { BookingTotalPrice } from './BookingTotalPrice'

interface OrderTotalPricePreviewProps {
    detailOrder: DetailOrder
    hideStatus?: boolean
}

export const OrderTotalPricePreview: FC<OrderTotalPricePreviewProps> = ({
    detailOrder,
    hideStatus,
}) => (
    <StyledFooterContainer>
        <StyledItemsContainer>
            <List>
                {detailOrder.bookings.map((booking, index) => (
                    <BookingTotalPrice
                        booking={booking}
                        counterpartyDiscount={detailOrder.counterpartyDiscount}
                        key={index}
                        isOrderItemMode
                    />
                ))}
            </List>

            {!hideStatus && (
                <Flex justifyContent='space-between' gap={10}>
                    <OrderPaidStatus
                        total={detailOrder.totalPriceWithDiscount}
                        paid={detailOrder.totalAmountPaid}
                    />
                </Flex>
            )}
        </StyledItemsContainer>
    </StyledFooterContainer>
)
